import { PopupContainer } from "../popup";
import territoriesImage from "../../assets/join-as-designer-page/territory.jpg";
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { DmaMap } from "../dma-map";

export const TerritoriesPopup = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  if (!visible) return null;
  return (
    <PopupContainer
      maxWidth={"800px"}
      onClose={onClose}
      title="Available Territories"
    >
      <DmaMap hideInput />
    </PopupContainer>
  );
};
